import { defineStore } from 'pinia';
import api from '../plugins/axios';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
        token: localStorage.getItem('auth_token') || null,
        company: null,
    }),
    getters: {
        isAuthenticated: (state) => !!state.token,
        isAdmin: (state) => state.user?.roles?.some(r => r.name === 'super-admin' || r.name === 'super_admin' || r.name === 'admin') || false,
    },
    actions: {
        async login(credentials) {
            const response = await api.post('/auth/login', credentials);
            // Handle 2FA or direct login
            if (response.data.requires_2fa) {
                return { requires_2fa: true, temp_token: response.data.temp_token };
            }
            this.setAuth(response.data.data.access_token, response.data.data.user);
            return response.data.data;
        },
        async fetchUser() {
            if (!this.token) return;
            try {
                const response = await api.get('/auth/me');
                this.user = response.data.data;
            } catch (error) {
                this.logout();
            }
        },
        setAuth(token, user) {
            this.token = token;
            this.user = user;
            localStorage.setItem('auth_token', token);
        },
        logout() {
            this.token = null;
            this.user = null;
            localStorage.removeItem('auth_token');
        }
    }
});
